<template>
  <div :class="$style.errors">
    <div class="pt-4 pb-4 d-flex align-items-end mt-auto">
      <img src="resources/images/logo.png" alt="logo" style="height: 100px;" />
    </div>
    <div class="pl-5 pr-5 pt-5 pb-5 mb-auto text-dark font-size-30" :class="$style.container">
      <div class="font-weight-bold mb-3">Niet toegestaan</div>
      <div>Volgens ons systeem ben je niet gemachtigd om deze pagina te bekijken.</div>
      <div class="font-weight-bold font-size-70 mb-1">401 —</div>
      <router-link to="/" class="btn btn-outline-primary width-100">Ga Terug</router-link>
    </div>
    <div class="mt-auto pb-5 pt-5">
      <ul
        class="list-unstyled d-flex mb-2 flex-wrap justify-content-center"
        :class="$style.footerNav"
      >
      </ul>
      <div class="text-gray-4 text-center">© 2020 Royal Parking. All rights reserved.</div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AirError401',
}
</script>
<style lang="scss" module>
@import "@/components/system/Errors/style.module.scss";
</style>
